import { Loader } from "@jti/core-components/components/Loader";
import { newrelic } from "@jti/fe-clients";

import { useCustomerOrder } from "@checkout-v2/shared/hooks/useCustomerOrder";

import { useOrderItemsMappedToSummaryItems } from "../hooks/useOrderItemsMappedToSummaryItems";
import { ItemsSummaryView } from "../ItemsSummaryView";

export const OrderItemsSummaryContainer = () => {
  const orderQueryState = useCustomerOrder();
  const { summaryItems } = useOrderItemsMappedToSummaryItems(orderQueryState.data?.items);

  if (orderQueryState.isLoading) {
    return <Loader />;
  }

  if (orderQueryState.error) {
    const errorMessage =
      orderQueryState.error instanceof Error ? orderQueryState.error.message : String(orderQueryState.error);
    newrelic.noticeError(new Error(`OrderItemsSummaryContainer rendering failed due to error: ${errorMessage}`));
    return null;
  }

  return <ItemsSummaryView summaryItems={summaryItems} />;
};
